import { ActivityReason, DocumentActivityType, } from '@office-start/document-types';
export function convertActivityTypeToActivityReason(type) {
    switch (type) {
        case DocumentActivityType.FrequentlyOpen:
        case DocumentActivityType.RecentlyOpen:
        case DocumentActivityType.WeeklyOpen:
            return ActivityReason.Open;
        case DocumentActivityType.SingleEditYou:
        case DocumentActivityType.MultipleEditOthers:
        case DocumentActivityType.MultipleEditYouAndOthers:
        case DocumentActivityType.SingleEditOthers:
            return ActivityReason.Edit;
        case DocumentActivityType.SingleCommentYou:
        case DocumentActivityType.SingleCommentOthers:
        case DocumentActivityType.MultipleCommentOthers:
        case DocumentActivityType.MultipleCommentYouAndOthers:
            return ActivityReason.Comment;
        case DocumentActivityType.CommentReplyToYou:
        case DocumentActivityType.CommentReplyYou:
        case DocumentActivityType.CommentReplyOthers:
            return ActivityReason.CommentReply;
        case DocumentActivityType.SharedWithMe:
            return ActivityReason.Share;
        case DocumentActivityType.EmailAttachment:
            return ActivityReason.Attachment;
        case DocumentActivityType.SingleMentionYou:
        case DocumentActivityType.MultipleMentionYouAndOthers:
        case DocumentActivityType.SingleMentionOthers:
        case DocumentActivityType.MultipleMentionOthers:
        case DocumentActivityType.SingleMentionedYou:
        case DocumentActivityType.MultipleMentionedYou:
            return ActivityReason.Mention;
        case DocumentActivityType.SnoozeExpiry:
            return ActivityReason.SnoozeExpiry;
        case DocumentActivityType.Trending:
        case DocumentActivityType.PeakMoment:
        case DocumentActivityType.HighEngagement:
            return ActivityReason.Trending;
        case DocumentActivityType.Meeting:
            return ActivityReason.Meeting;
        case DocumentActivityType.SingleTaskActivityByYou:
        case DocumentActivityType.MultipleTaskActivityByYou:
        case DocumentActivityType.SingleTaskActivityByOthers:
        case DocumentActivityType.MultipleTaskActivityByOthers:
        case DocumentActivityType.SingleTaskActivityYouAssignee:
        case DocumentActivityType.MultipleTaskActivityYouAssignee:
        case DocumentActivityType.SingleTaskActivityYouCreator:
        case DocumentActivityType.MultipleTaskActivityYouCreator:
        case DocumentActivityType.AddToToDo:
            return ActivityReason.Task;
        case DocumentActivityType.ConvertToPdf:
        case DocumentActivityType.PdfCreated:
            return ActivityReason.Pdf;
        default:
            return ActivityReason.Default;
    }
}
function getPeopleFromActivity(actionUsers) {
    var people = [];
    if (actionUsers) {
        actionUsers.forEach(function (actionUser) {
            if (actionUser.user) {
                people.push({
                    name: actionUser.user.displayName,
                    upn: actionUser.user.userPrincipalName,
                });
            }
        });
    }
    return people;
}
function getActivityReasonFromAction(activityAction) {
    if (activityAction.edit) {
        return ActivityReason.Edit;
    }
    else if (activityAction.comment) {
        return ActivityReason.Comment;
    }
    else if (activityAction.mention) {
        return ActivityReason.Mention;
    }
    else if (activityAction.taskCreated ||
        activityAction.taskReopened ||
        activityAction.taskReassigned ||
        activityAction.taskCompleted) {
        return ActivityReason.Task;
    }
    else {
        return null;
    }
}
export function convertRecentActivities(recentActivities) {
    var activities = [];
    recentActivities.forEach(function (recentActivity) {
        var _a;
        var activityAction = recentActivity.a;
        var activityReason = (_a = getActivityReasonFromAction(activityAction)) !== null && _a !== void 0 ? _a : ActivityReason.None;
        var people = [];
        if (activityReason === ActivityReason.Mention &&
            activityAction.mention) {
            people = getPeopleFromActivity(activityAction.mention.mentionees);
        }
        else if (activityReason === ActivityReason.Task) {
            if (activityAction.taskCreated) {
                people = getPeopleFromActivity(activityAction.taskCreated.assignees);
            }
            else if (activityAction.taskReopened) {
                people = getPeopleFromActivity(activityAction.taskReopened.assignees);
            }
            else if (activityAction.taskReassigned) {
                people = getPeopleFromActivity(activityAction.taskReassigned.assignees);
            }
            else if (activityAction.taskCompleted) {
                people = getPeopleFromActivity(activityAction.taskCompleted.assignees);
            }
        }
        activities.push({
            id: recentActivity.r,
            actor: {
                name: recentActivity.da.n,
                id: recentActivity.da.i,
                upn: recentActivity.da.e,
            },
            timestamp: recentActivity.t,
            reasonType: activityReason,
            formatString: '',
            people: people,
            plainText: '',
        });
    });
    return activities;
}
//# sourceMappingURL=activitiesHelper.js.map